export default __webpack_public_path__ + "static/media/Cuprum-Bold.f897fbbf.ttf";